export default {
    validate: value => /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/.test(String(value)),
    message: "Senha informada deve conter ao menos um caractere alfabético e um caractere numérico."
}